import React from 'react';
import { SvgIcon } from '@mui/material';

const IconWrapper = ({ children, color = 'currentColor', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {children}
  </svg>
);

export const PinnedIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M12 2L2 22h20L12 2z" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="12" cy="21.5" r="1" fill="currentColor" />
  </SvgIcon>
);

export const PinnedAxiallyReleasedIcon = ({ color = '#424242', size = 24 }) => (
  <IconWrapper color={color} size={size}>
    <path
      d="M12 4L4 20H20L12 4Z"
      fill={color}
      stroke={color}
      strokeWidth="1.5"
    />
    <circle cx="8" cy="20" r="2" fill={color} />
    <circle cx="16" cy="20" r="2" fill={color} />
  </IconWrapper>
);

export const FixedIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {/* Vertical line */}
    <line x1="4" y1="2" x2="4" y2="22" stroke="currentColor" strokeWidth="1.5" />
    {/* Hatching lines */}
    <line x1="4" y1="5" x2="10" y2="11" stroke="currentColor" strokeWidth="1" />
    <line x1="4" y1="10" x2="10" y2="16" stroke="currentColor" strokeWidth="1" />
    <line x1="4" y1="15" x2="10" y2="21" stroke="currentColor" strokeWidth="1" />
  </SvgIcon>
);

export const SpringIcon = (props) => {
    const turns = 3;
    const radiusGrowth = 9;
    const startRadius = 1;
    const numSegments = turns * 16;
    let pathData = "M 12,12";
    for (let i = 0; i <= numSegments; i++) {
        const angle = (i / numSegments) * turns * 2 * Math.PI;
        const radius = startRadius + radiusGrowth * (i / numSegments);
        const x = 12 + radius * Math.cos(angle);
        const y = 12 + radius * Math.sin(angle);
        pathData += ` L ${x.toFixed(2)},${y.toFixed(2)}`;
    }
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path d={pathData}
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"/>
        </SvgIcon>
    );
};

// Free End (No specific icon, represented by absence)
// Roller Support (Circle on a line - If needed later)
// export const RollerIcon = (props) => (
//     <SvgIcon {...props} viewBox="0 0 24 24">
//         <path d="M12 10 L2 20 h20 L12 10z" fill="none" stroke="currentColor" strokeWidth="1.5" />
//         <circle cx="12" cy="21" r="2" fill="none" stroke="currentColor" strokeWidth="1.5" />
//         <line x1="4" y1="23" x2="20" y2="23" stroke="currentColor" strokeWidth="1.5" />
//     </SvgIcon>
// ); 